import { Button, Input } from "antd";
import { Controller, useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router";
import "../../index.css";
import "./Auth.css";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";
import { setLocalStorageItem } from "../../utils/Validation";
import "./Login.css";
import { encryptData } from "../../utils";

type FormValues = {
  email: string;
  password: string;
};

const Login = () => {
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({
    mode: "onBlur", // Validation triggered on blur
  });

  const onSubmit = async (data: FormValues) => {
    try {
      // Encrypt password before sending
      const encryptedPassword = encryptData(data.password);

      const response: {
        token: string;
        message: string;
        name: string;
        email: string;
        userId: string;
      } = await apiService.post("/auth/login", {
        email: data.email,
        password: encryptedPassword,
      });

      if (response) {
        setLocalStorageItem("authToken", response.token);
        setLocalStorageItem("detail", {
          name: response.name,
          email: response.email,
          userId: response.userId,
        });
        navigate("/");
      }
    } catch (error) {
      toast.error((error as any)?.message ? (error as any)?.message : error);
    }
  };
  return <>
    <div className="login-container container">
      <div className="login-form">
        <div className="form-header login-header">Welcome to Astrafin</div>
        <p className="form-paragraph">
          Please sign-in to your account and start the adventure
        </p>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* <div style={{ paddingTop: "30px" }}>
                          <div className="form-label login-label">Email</div>
                          <Input size="large" style={{ height: "48px", borderRadius: "4px" }} />
                      </div> */}
          <div style={{ paddingTop: "30px" }}>
            <div className="form-label login-label">Email</div>
            <Controller
              name="email"
              control={control}
              rules={{
                required: "Please enter your email!",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email!",
                },
              }}
              render={({ field }) => (
                <Input
                  {...field}
                  size="large"
                  className={errors.email ? "ant-input-status-error" : ""}
                  style={{ height: "48px", borderRadius: "4px" }}
                />
              )}
            />
            {errors.email && (
              <div className="ant-form-item-explain-error">
                {errors.email.message}
              </div>
            )}
          </div>
          {/*  <div style={{ paddingTop: "30px" }}>
                          <div className="form-label login-label">Password</div>
                          <Input.Password size="large" style={{ height: "48px", borderRadius: "4px" }} />
                      </div> */}

          <div style={{ paddingTop: "30px" }}>
            <div className="form-label login-label">Password</div>
            <Controller
              name="password"
              control={control}
              rules={{
                required: "Please enter your password!",
              }}
              render={({ field }) => (
                <Input.Password
                  {...field}
                  size="large"
                  className={errors.password ? "ant-input-status-error" : ""}
                  style={{ height: "48px", borderRadius: "4px" }}
                />
              )}
            />
            {errors.password && (
              <div className="ant-form-item-explain-error">
                {errors.password.message}
              </div>
            )}
          </div>
          <div
            style={{ paddingTop: "20px" }}
            className="forgot-password-label"
          >
            <Link to="/forgot-password" className="forgot-password-label">
              Forgot your Password?
            </Link>
          </div>
          <div style={{ paddingTop: "30px" }}>
            <Button
              color="primary"
              variant="solid"
              size="large"
              className="form-button"
              htmlType="submit"
            >
              Sign in
            </Button>
          </div>
        </form>
      </div>
    </div>
  </>;
};

export default Login;
